module.exports = __webpack_public_path__ + "static/mansion_350-fcff27848c2a1693fedab8d1db889bb0.webp";